import { render, staticRenderFns } from "./DisplaySingleProject.vue?vue&type=template&id=ac4f4f52&scoped=true&"
import script from "./DisplaySingleProject.vue?vue&type=script&lang=js&"
export * from "./DisplaySingleProject.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySingleProject.vue?vue&type=style&index=0&id=ac4f4f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4f4f52",
  null
  
)

export default component.exports